import QuickJobsApi, { IPaginationParams } from ".";

class Reviews {
  protected client: QuickJobsApi;
  constructor(client: QuickJobsApi) {
    this.client = client;
  }

  public getAllReviews(params?: IPaginationParams) {
    return this.client.httpClient.get("/reviews", {
      params: {
        ...params
      }
    });
  }

  public remove(id: number) {
    return this.client.httpClient.delete(`/reviews/${id}`);
  }
}

export default Reviews;



// WEBPACK FOOTER //
// ./src/libs/quickjobs-api/reviews.ts